export class PDFConfig {
    public static get fonts() { return fonts }
    public static get pageMargins() { return pageMargins }
}

const fonts = {
    Roboto: {
        normal: 'Times-Roman',
        italics: 'Times-Roman',
        bolditalics: 'Times-Roman'
    }
}

const pageMargins = [50, 65, 50, 55]